import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import { OffEmailsDir } from 'modules/general';
import { useGenerationEmailPicker, type GenerationEmailFieldProps } from './model';

const GenerationEmailField = (props: GenerationEmailFieldProps) => {
    const { value, onChange, placeholder, disabled } = props;
    const { t } = useTranslation('EmailsDir');
    const { showPicker, openPicker, closePicker, selectEmails } = useGenerationEmailPicker(props);
    return (
        <>
            <div className="d-flex align-items-center gap-2">
                <Form.Control type="text" value={value} onChange={(event) => onChange(event.target.value)} onFocus={(event) => event.target.select()} placeholder={placeholder} autoComplete="email" disabled={disabled} />
                <Button type="button" size="sm" variant="light-secondary" className="icon-btn-24 flex-shrink-0" disabled={disabled} onClick={openPicker} title={t('openPicker')} aria-label={t('openPicker')}>
                    <SolarIcon name="card-list" />
                </Button>
            </div>
            <OffEmailsDir show={showPicker} onHide={closePicker} onSelect={selectEmails} />
        </>
    );
};

export default GenerationEmailField;
